import { render, staticRenderFns } from "./firmwareBatchDetail.vue?vue&type=template&id=1b8631d0&scoped=true&"
import script from "./firmwareBatchDetail.vue?vue&type=script&lang=js&"
export * from "./firmwareBatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./firmwareBatchDetail.vue?vue&type=style&index=0&id=1b8631d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8631d0",
  null
  
)

export default component.exports